module.exports = __webpack_public_path__ + "img/PS17.3fd13164.png";